import { translate as t } from "../translate/localization";

const nifRegex = /^[a-zA-Z0-9]{6,}$/i;

export const fieldTypesConfig = {
  legalId: {
    validation: (val: string): boolean => nifRegex.test(val),
    message: t("employees-section.invalid-legal-id"),
  },
};

export default function validateFieldByType({ type }: { type: string }) {
  return type in fieldTypesConfig && fieldTypesConfig[type].validation;
}
